import React from 'react';
import HeartIcon from 'react-icons/lib/md/favorite';

const Heart = ({
  x,
  y,
  size,
}) => (
  <HeartIcon size={size} />
)
export default Heart;


// WEBPACK FOOTER //
// ./src/core/add-ons/heart.js